<template>
  <div class="card video-effect">
    <popup-spinner
      :opened="isPopOpend"
      @popupOff="spinnerOpend"
    ></popup-spinner>
    <div class="step-nav">
      <button type="button" class="move-back" @click="goPrev">
        <i class="material-icons">arrow_back_ios</i>
      </button>
    </div>
    <div class="header">
      <h2 v-html="`1. ${$t('mov_making.picture_title')}`"></h2>
    </div>
    <div class="body">
      <p class="information" v-html="$t('mov_making.picture_description')"></p>
      <form action="#">
        <div class="type-box">
          <div class="form-box">
            <label v-html="$t('sign_resolution')"></label>
            <label
              class="resolution"
              v-html="
                `${$t('common.t_hor')} ${data.product_type_info.h_res} x ${$t(
                  'common.t_ver',
                )} ${data.product_type_info.v_res} ` +
                `(${$t('type_of_installation')} : ${data.rotate_text})`
              "
            >
            </label>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.picture_name')"></label>
            <div class="input-group">
              <input
                id="mov_name"
                v-model="data.mov_name"
                type="text"
                class="mov_name"
                maxlength="50"
              />
              <button
                type="button"
                :class="['button-delete', { show: data.mov_name }]"
                @click="clearMovName()"
              >
                X
              </button>
            </div>
          </div>

          <div class="form-box input-time-group">
            <label v-html="$t('mov_making.playtime')"></label>
            <div class="input-area-group">
              <div class="input-area">
                <select
                  id="playMinutes"
                  v-model="playTime.minutes"
                  class="effect-select"
                  :aria-label="$t('popup_play_add.text_minutes')"
                  @change="changePlayMinutes()"
                >
                  <template v-for="(i, index) in maxPlayMinutes + 1">
                    <option
                      :key="i"
                      :value="index"
                      v-text="index + $t('popup_play_add.text_minutes')"
                    ></option>
                  </template>
                </select>
              </div>
              <div class="input-area">
                <select
                  v-model="playTime.seconds"
                  class="effect-select"
                  :aria-label="$t('popup_play_add.text_seconds')"
                  @change="changePlaySeconds"
                >
                  <template v-for="(i, index) in 60">
                    <option
                      :key="i"
                      :value="index"
                      :disabled="isDisablePlaySeconds(index)"
                      v-text="index + $t('popup_play_add.text_seconds')"
                    ></option>
                  </template>
                </select>
              </div>
              <div class="input-area"></div>
            </div>
          </div>
          <div class="form-box" v-if="isMultiCanvas">
            <label v-html="$t('mov_making.select_canvas')"></label>
            <div class="text-row">
              <ul>
                <li
                  :class="{ 'clicked-tab': activeCanvasId === 'canvasScreen' }"
                  @click.prevent="selectCanvas('canvasScreen')"
                >
                  <span v-text="$t('mov_making.canvas_front')"></span>
                </li>
                <li
                  :class="{
                    'clicked-tab': activeCanvasId === 'canvasScreenSecond',
                  }"
                  @click.prevent="selectCanvas('canvasScreenSecond')"
                >
                  <span v-text="$t('mov_making.canvas_back')"></span>
                </li>
              </ul>
            </div>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.select_background')"></label>
            <button
              type="button"
              class="ghostButton orange"
              @click="cropperOpen(0)"
              v-text="$t('mov_making.add_background')"
            ></button>
            <button
              type="button"
              class="ghostButton orange"
              @click.prevent="removeBackground"
              v-text="$t('mov_making.remove_background')"
            ></button>
          </div>
          <div class="form-box">
            <label
              class="form-box"
              v-text="$t('movie_list.sub_btn_preview')"
            ></label>
            <div class="effect">
              <div class="canvas-container">
                <div
                  v-show="activeCanvasId === 'canvasScreen'"
                  class="canvas-box"
                >
                  <canvas
                    id="canvasScreen"
                    :width="data.width"
                    :height="data.height"
                  ></canvas>
                  <p
                    v-if="isMultiCanvas"
                    class="position-text"
                    v-html="
                      `${$t('mov_making.location_of_selected_object')}
                      - ( left: ${pos.x}, top: ${pos.y} )`
                    "
                  ></p>
                </div>
                <div
                  v-show="
                    isMultiCanvas && activeCanvasId === 'canvasScreenSecond'
                  "
                  class="canvas-box"
                >
                  <canvas
                    id="canvasScreenSecond"
                    :width="data.width"
                    :height="data.height"
                  ></canvas>
                  <p
                    v-if="isMultiCanvas"
                    class="position-text"
                    v-html="
                      `${$t('mov_making.location_of_selected_object')}
                      - ( left: ${pos.x}, top: ${pos.y} )`
                    "
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.text')"></label>
            <button
              type="button"
              class="ghostButton blue"
              @click.prevent="addText"
              v-html="$t('mov_making.add')"
            ></button>
            <button
              type="button"
              class="ghostButton blue"
              @click.prevent="removeText"
              v-html="$t('mov_making.remove')"
            ></button>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.select_font')"></label>
            <select
              v-model="selectedFont"
              name="fontFamily"
              @change.prevent="changeFontFamily"
            >
              <!-- 한국어 폰트 -->
              <template v-if="!isLangJP">
                <option value="YogiyoJalnan">기본 폰트</option>
                <option value="NotoSansKRBold">Noto Sans KR</option>
              </template>
              <!-- 일본어 폰트 -->
              <template v-else-if="isLangJP">
                <option value="MeiryoBold">基本フォント</option>
                <option value="MPLUS1pBlack">MPLUS</option>
                <option value="MPLUSRounded1cExtraBold">MPLUSRounded</option>
              </template>
            </select>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.select_stroke_width')"></label>
            <select
              v-model="selectedStrokeWidth"
              name="strokeWidth"
              @change.prevent="changeStrokeWidth"
            >
              <option value="0" v-text="$t('mov_making.none')"></option>
              <option value="1" v-text="$t('mov_making.thin')"></option>
              <option value="2" v-text="$t('mov_making.thick')"></option>
            </select>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.text_align')"></label>
            <select
              v-model="selectedTextAlign"
              name="textAlign"
              @change.prevent="changeTextAlign"
            >
              <option value="center" v-text="$t('mov_making.center')"></option>
              <option value="left" v-text="$t('mov_making.left')"></option>
              <option value="right" v-text="$t('mov_making.right')"></option>
            </select>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.add_sticker')"></label>
            <div
              id="drop"
              class="inactive"
              @mouseover="changeClassTo('dragging')"
              @mouseout="changeClassTo('inactive')"
              @mouseclick="changeClassTo('inactive')"
              @dragenter.prevent="getImageHandleDragEnter"
              @dragleave.prevent="getImageHandleDragLeave"
              @dragover.prevent="getImageHandleDragOver"
              @drop.prevent="getImageHandleDragDrop"
            >
              <label
                class="selectedFile"
                for="selectedFile"
                v-html="$t('mov_making.msg_drag_and_drop_to_upload')"
              ></label>
              <input
                id="selectedFile"
                type="file"
                multiple="true"
                accept="image/*"
                @input="selectedFile"
              />
            </div>
          </div>
          <div v-show="data.isShowStickerList" class="form-box">
            <label></label>
            <div id="select-sticker">
              <div class="stickers">
                <div id="image-preview"></div>
              </div>
            </div>
          </div>
          <div v-show="data.isShowStickerList" class="form-box">
            <label v-text="$t('mov_making.remove_sticker')"></label>
            <button
              type="button"
              class="removeButton"
              @click="removeSticker"
              v-text="$t('mov_making.remove_selected_sticker')"
            ></button>
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.sticker_priority')"></label>
            <div class="radio-box">
              <input
                id="text"
                type="radio"
                name="textOnTop"
                :checked="textOnTop"
                @change.prevent="setElementOnTop(true)"
              />
              <label for="text" v-html="$t('mov_making.text_on_top')"></label>
              <input
                id="sticker"
                type="radio"
                name="textOnTop"
                :checked="!textOnTop"
                @change.prevent="setElementOnTop(false)"
              />
              <label
                for="sticker"
                v-html="$t('mov_making.sticker_on_top')"
              ></label>
            </div>
          </div>

          <div class="form-box">
            <label v-html="$t('mov_making.movtxt_color')"></label>
            <input
              v-model="color"
              type="color"
              class="textColor"
              @input="setTextColor"
            />
          </div>
          <div class="form-box">
            <label v-html="$t('mov_making.movtxt_border_color')"></label>
            <input v-model="bgColor" type="color" @input="setTextBgColor" />
          </div>
        </div>
      </form>
    </div>
    <div class="footer">
      <button
        type="button"
        class="button primary move-back"
        @click="goPrev"
        v-text="$t('common.t_prev')"
      ></button>
      <button
        id="makePicture"
        type="button"
        :class="[
          'button',
          { primary: data.mov_name },
          { normal: !data.mov_name },
        ]"
        :disabled="!data.mov_name"
        @click.prevent="processImage"
        v-text="$t('mov_making.step_three', { isInsertEnter: '' })"
      ></button>
      <button
        id="downloadBtn"
        type="button"
        class="button primary hidden"
        @click.prevent="videoDownload()"
        v-text="$t('mov_making.video_download')"
      ></button>
    </div>
    <PopupCropper
      :opened="isCropperOpened"
      @cropperPopupOnOff="isCropperOpened = false"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import Cookies from 'js-cookie';
import JSZip from 'jszip';
import { fabric } from 'fabric';
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import { API } from '@config/common';
import EventBus from '@utils/bus';
import * as editableCanvas from '@action/editable_canvas';
import videoData from '@api/video';
import storeVideo from '@store/video';
import PopupSpinner from '@components/PopupSpinner.vue';
import PopupCropper from '@components/PopupCropper.vue';

const data = {
  access_type: undefined, // 접근 유형 (app, web)
  model: '', // 디바이스 유형
  product_type_id: '', // 디바이스 ID
  access_token: '',
  product_type_info: {}, // 디바이스 정보
  step_type: null, // 제작 단계
  mov_name: '', // 영상 이름
  img_list: {}, // 선택 사진 목록 - img_list_tmp 배열 키값에 이미지 주소가 있는 경우 (플레이 버튼 누를 시 입력)
  img_list_tmp: {}, // 임시 선택 사진 목록 - 이미지 최대 개수대로 배열 키값이 초기화되고 Cropper로 추가/제거 시 입력
  img_list_count: 0, // 이미지 개수 (플레이 버튼 누를 시 입력)
  img_list_len: 2, // 이미지 최대 개수
  img_prefix: 'video', // 이미지 고정 이름
  img_ext: 'jpg', // 이미지 확장자
  duration: 15000, // 영상 시간
  width: 0, // 캔버스 가로폭
  height: 0, // 캔버스 세로폭
  rotate: 'H',
  rotate_text: '',
  stickers: [],
  dragStatusCount: 0,
  isShowStickerList: false,
  isAlertDuplicated: false,
  isPressed: false,
};

export default {
  name: 'mov_image',
  head: {
    title: {
      inner: 'Video',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Edit Video Of Smart Solution',
      },
    ],
  },
  props: ['step_type', 'step_info'],
  components: {
    PopupSpinner,
    PopupCropper,
  },
  computed: {
    isMaxPlayTime() {
      const playTime = this.playTime.minutes * 60 + this.playTime.seconds;
      return playTime >= this.maxPlayTime;
    },
    maxPlayMinutes() {
      return Math.floor(this.maxPlayTime / 60);
    },
    maxPlaySeconds() {
      const maxSeconds = 59;
      const limitSeconds = this.maxPlayTime - this.playTime.minutes * 60;

      if (limitSeconds > maxSeconds) {
        return maxSeconds;
      }

      return limitSeconds;
    },
  },
  data() {
    return {
      data,
      access_type: '',
      selected_lang: '',
      isPopOpend: false,
      isCropperOpened: false,
      activeCanvasId: 'canvasScreen',
      playTime: {
        minutes: 0,
        seconds: 15,
      },
      maxPlayTime: 180,
      isMultiCanvas: false,
      selectedFont: 'YogiyoJalnan',
      selectedStrokeWidth: 1,
      selectedTextAlign: 'center',
      color: '#ffffff',
      bgColor: '#000000',
      textOnTop: true,
      pos: {
        x: 0,
        y: 0,
        set({ x, y }) {
          this.x = Math.floor(x);
          this.y = Math.floor(y);
        },
      },
      isLangJP: false,
    };
  },
  created() {
    data.product_type_id = this.step_info.product_type_id;
    data.product_type_info = videoData.product_type_info;
    this.access_type = sessionStorage.getItem('access_type');
    this.selected_lang = Cookies.get(Common.STORAGE_LANG);
    this.resetImgList();
    this.dataInit();
    this.receiveEventInit();
    this.domEventInit();
  },
  destroyed() {
    EventBus.$off('insertCropImage');
    EventBus.$off('is-opend');
  },
  methods: {
    dataInit() {
      // 디바이스 타입에 따른 크기 조정
      const { h_res: hRes, v_res: vRes, rotate } = data.product_type_info;
      const ENLARGEMENT_UNIT = this.getEnlargementUnit({ hRes, vRes });
      data.width = hRes * ENLARGEMENT_UNIT;
      data.height = vRes * ENLARGEMENT_UNIT;
      data.rotate = rotate;
      this.isMultiCanvas = data.product_type_info.dup_type === 'D';
      this.isLangJP = Cookies.get(Common.STORAGE_LANG) === Common.CONST_LANG_JA;
      this.selectedFont = this.isLangJP ? 'MeiryoBold' : 'YogiyoJalnan';

      if (data.product_type_info.rotate === 'H') {
        data.rotate_text = eve.Lang.t('common.t_hor');
      } else {
        data.rotate_text = eve.Lang.t('common.t_ver');
      }
    },
    receiveEventInit() {
      // Cropper 완료된 배경이미지를 캔버스에 삽입
      EventBus.$on('insertCropImage', (info) => {
        fabric.Image.fromURL(info.url, (img) => {
          img.set({ selectable: false });
          data[this.activeCanvasId].setBackgroundImage(img, () => {
            data[this.activeCanvasId].renderAll();
          });
        });
        data.img_list_tmp[this.activeCanvasId] = info.url;
      });

      EventBus.$on('is-opend', (res) => {
        this.isPopOpend = false;

        if (res === 'state_encode') {
          document.querySelector('#downloadBtn').classList.remove('hidden');
          document.querySelector('#makePicture').classList.add('hidden');
        }
      });
    },
    domEventInit() {
      setTimeout(() => {
        data.canvasScreen = editableCanvas.setCanvasSetting(
          'canvasScreen',
          data,
        );

        if (this.isMultiCanvas) {
          data.canvasScreenSecond = editableCanvas.setCanvasSetting(
            'canvasScreenSecond',
            data,
          );
        }

        this.initFontFamily();

        if (document.querySelector('#mov_name') !== '') {
          document.querySelector('#makePicture').classList.add('primary');
          document.querySelector('#makePicture').classList.remove('normal');
        }

        this.canvasEventInit();
      });
    },
    resetImgList() {
      /* 이미지 리스트 초기화 */
      data.img_list = [];
      data.img_list_count = 0;

      for (let i = 1; i <= data.img_list_len; i += 1) {
        data.img_list_tmp[this.imgNaming(i)] = '';
      }
    },
    imgNaming(n) {
      // 이미지 네이밍 추출 (n = 숫자)
      return `${data.img_prefix + n}.${data.img_ext}`;
    },
    getEnlargementUnit({ hRes, vRes }) {
      /* 캔버스 사이즈가 너무 작은 경우 편집의 용이성을 위해 캔버스의 비율을 키움 */
      let unit = 1;

      if (hRes <= 320 && vRes <= 320) unit = 2;
      if (hRes <= 160 && vRes <= 160) unit = 3;

      return unit;
    },
    initFontFamily() {
      const fontList = [
        'YogiyoJalnan',
        'NotoSansKRBold',
        'MeiryoBold',
        'MPLUS1pBlack',
        'MPLUSRounded1cExtraBold',
      ];
      _.forEach(fontList, (text) => {
        const textOption = editableCanvas.makeText({
          fontFamily: text,
          left: 999,
          top: 999,
        });
        data.canvasScreen.add(textOption);
      });
    },
    canvasEventInit() {
      // 선택된 오브젝트의 위치 구하기
      data[this.activeCanvasId].on('selection:created', (e) => {
        this.updatePosition(e);
      });
      data[this.activeCanvasId].on('selection:updated', (e) => {
        this.updatePosition(e);
      });
      data[this.activeCanvasId].on('object:moving', (e) => {
        this.updatePosition(e);
      });

      // 스티커를 클릭한 후 delete 버튼을 누르면 삭제하도록 함
      window.addEventListener('keydown', (e) => {
        if (!data[this.activeCanvasId]) return;
        if (!data[this.activeCanvasId].getActiveObject()) return;

        // Delete Key Pressed
        if (e.keyCode === 46) {
          const obj = data[this.activeCanvasId].getActiveObject();
          if (obj.type === 'i-text' && !obj.isEditing) {
            data[this.activeCanvasId].remove(obj);
          }
          if (_.size(data.stickers) && obj.type === 'image') {
            this.removeSticker(e);
          }
        }
      });
    },
    updatePosition(e) {
      const { x, y } = e.target.aCoords.tl;
      this.pos.set({ x, y });
    },
    removeSticker(e) {
      e.preventDefault();
      const target = data[this.activeCanvasId].getActiveObject();

      if (!target) {
        alert(eve.Lang.t('mov_making.select_img_to_delete'));
        return;
      }
      // 여러개의 스티커를 선택한 경우
      // eslint-disable-next-line no-underscore-dangle
      if (target._objects) {
        // eslint-disable-next-line no-underscore-dangle
        target._objects.forEach((list) => {
          data.stickers.splice(data.stickers.indexOf(target), 1);
          data[this.activeCanvasId].remove(list);
        });
        // 한개의 스티커를 선택한 경우
      } else {
        data.stickers.splice(data.stickers.indexOf(target), 1);
        data[this.activeCanvasId].remove(target);
      }
      // 스티커 전체 선택 해제
      data[this.activeCanvasId].discardActiveObject();
      this.changeTextPriority();
    },
    changeTextPriority() {
      this.setElementOnTop(this.textOnTop);
    },
    setElementOnTop(textOnTop) {
      this.textOnTop = textOnTop;

      data.canvasScreen.discardActiveObject();
      if (this.isMultiCanvas) data.canvasScreenSecond.discardActiveObject();

      const texts = data[this.activeCanvasId].getObjects();
      if (_.size(texts) && textOnTop) {
        texts.forEach((text) => {
          if (text.type === 'i-text') {
            data[this.activeCanvasId].bringToFront(text);
          }
        });
      } else if (_.size(texts) && !textOnTop) {
        texts.forEach((text) => {
          if (text.type === 'i-text') {
            data[this.activeCanvasId].sendToBack(text);
          }
        });
      }
    },
    changeFontFamily(e) {
      const { name, value } = e.target;
      this.changeProperty(name, value);
    },
    changeTextAlign(e) {
      const { name, value } = e.target;
      this.changeProperty(name, value);
    },
    changeStrokeWidth(e) {
      const { name, value } = e.target;
      this.changeProperty(name, parseInt(value, 10));
    },
    changeProperty(name, value) {
      const text = data[this.activeCanvasId].getActiveObject();
      if (text) {
        text.set({ [name]: value });
        data[this.activeCanvasId].renderAll();
      }
    },
    selectCanvas(type) {
      this.activeCanvasId = type;
      this.pos.set({ x: 0, y: 0 });
      this.canvasEventInit();
      this.setElementOnTop(this.textOnTop);
    },
    removeBackground() {
      data[this.activeCanvasId].setBackgroundImage(0, () => {
        data[this.activeCanvasId].renderAll();
      });
    },
    setDuration(minutes, seconds) {
      data.duration = minutes * 60000 + seconds * 1000;
    },
    changePlayMinutes() {
      const { minutes, seconds } = this.playTime;

      if (minutes === 0 && seconds === 0) {
        this.playTime.seconds = 1;
      } else if (seconds > this.maxPlaySeconds) {
        this.playTime.seconds = 0;
      }

      this.setDuration(this.playTime.minutes, this.playTime.seconds);
    },
    changePlaySeconds() {
      this.setDuration(this.playTime.minutes, this.playTime.seconds);
    },
    isDisablePlaySeconds(seconds = 0) {
      if (
        seconds > this.maxPlaySeconds ||
        (!seconds && this.playTime.minutes === 0)
      ) {
        return true;
      }

      return false;
    },
    addText() {
      const newText = editableCanvas.makeText({
        fill: this.color,
        stroke: this.bgColor,
        fontFamily: this.selectedFont,
        strokeWidth: this.selectedStrokeWidth,
        textAlign: this.selectedTextAlign,
        left: data.width / 2,
        top: data.height / 2,
      });
      data[this.activeCanvasId].add(newText);
      this.changeTextPriority();
    },
    removeText() {
      if (!data[this.activeCanvasId].getActiveObject()) {
        alert(eve.Lang.t('mov_making.select_text_to_delete'));
      }
      data[this.activeCanvasId].remove(
        data[this.activeCanvasId].getActiveObject(),
      );
    },
    setTextColor(e) {
      e.preventDefault();
      const selectedText = data[this.activeCanvasId].getActiveObject();
      if (e && selectedText) {
        selectedText.set({ fill: this.color });
        data[this.activeCanvasId].renderAll();
      }
    },
    setTextBgColor(e) {
      e.preventDefault();
      const selectedText = data[this.activeCanvasId].getActiveObject();
      if (e && selectedText) {
        selectedText.set({ stroke: this.bgColor });
        data[this.activeCanvasId].renderAll();
      }
    },
    validateImage(image) {
      // 이미지 확장자 체크
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/bmp'];
      if (validTypes.indexOf(image.type) === -1) {
        // 중복 알림 시 한개만 띄우도록 함
        if (!data.isAlertDuplicated) {
          alert(
            eve.Lang.t('mov_making.file_type_png', {
              file_type: 'png, jpg, bmp',
            }),
          );
          data.isAlertDuplicated = true;
          setTimeout(() => {
            data.isAlertDuplicated = false;
          }, 3000);
        }

        return false;
      }

      return true;
    },
    previewImage(image) {
      const imgView = document.getElementById('image-preview');
      const img = document.createElement('img');
      img.style.width = '50px';
      img.style.height = '50px';
      img.style.cursor = 'move';
      img.style.margin = '0 5px 5px 0';
      img.draggable = true;

      img.addEventListener('dragstart', this.handleDragStart);
      img.addEventListener('dragend', this.handleDrop);
      img.addEventListener('click', this.removeBorderFromCanvas);
      img.addEventListener('mousedown', this.addBorderToCanvas.bind(this));
      imgView.appendChild(img);

      const reader = new FileReader();
      reader.onload = (e) => {
        img.src = e.target.result;
      };
      reader.readAsDataURL(image);
    },
    async processImage() {
      /* 캔버스 이미지 저장하기 */
      const imgData = data.canvasScreen.toDataURL({ format: 'jpg' });
      const zip = new JSZip();
      const jpgFolder = zip.folder('jpg');
      jpgFolder.file(`1.jpg`, this.dataURItoBlob(imgData));

      if (this.isMultiCanvas) {
        const imgDataSecond = data.canvasScreenSecond.toDataURL({
          format: 'jpg',
        });
        jpgFolder.file(`2.jpg`, this.dataURItoBlob(imgDataSecond));
      }

      const zipItem = await zip.generateAsync({
        type: 'blob',
        compression: 'STORE',
      });
      const formData = new FormData();
      formData.append('url', this.getMakeURL());
      formData.append('file', zipItem);
      formData.append('product_type_id', data.product_type_id);
      formData.append('title', data.mov_name);
      formData.append('playtime_min', this.playTime.minutes);
      formData.append('playtime_sec', this.playTime.seconds);

      this.spinnerOpend();
      this.changeTextPriority();
      this.$store.dispatch('CONVERT_ONLY_IMAGE', formData);
    },
    videoDownload() {
      this.spinnerOpend();
      this.$store.dispatch('VIDEO_DOWNLOAD', {
        data: data.mov_name,
        jobId: storeVideo.state.job_id,
      });
    },
    getMakeURL() {
      let makeUrl = '';

      if (this.isMultiCanvas) {
        makeUrl = API.API_IMAGE_CONVERT_MULTI_ONLY_IMAGE;
      } else {
        makeUrl = API.API_IMAGE_CONVERT_ONLY_IMAGE;
      }

      return makeUrl;
    },
    imageToBlob() {
      const canvas = this.$refs.textCanvas;
      const ctx = canvas.getContext('2d');
      this.blobCount = 0;

      for (let i = 0; i < data.text_img_list.length; i += 1) {
        for (let j = 0; j < data.text_img_list[i].length; j += 1) {
          ctx.putImageData(data.text_img_list[i][j], 0, 0);
          canvas.toBlob((blob) => {
            data.text_img_list[i][j] = blob.slice();
            this.blobCount += 1;
          }, 'png');
        }
      }
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      let byteString;

      if (typeof dataURI === 'object') {
        // 정지 영상 제작 시 crop된 이미지 url이 string이 아닌 blob 형태로 넘어오는 경우
        // const chunk = dataURI.slice(0, dataURI.size, 'image/png');
        return new Blob([dataURI], { type: 'image/png' });
      }

      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }

      // separate out the mime component
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      const ia = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },
    removeBorderFromCanvas() {
      data.isPressed = false;
      document.querySelector(`#${this.activeCanvasId}`).style.border =
        '2px solid white';
    },
    addBorderToCanvas() {
      data.isPressed = true;
      this.doInterval();
    },
    doInterval() {
      if (data.isPressed) {
        document.querySelector(`#${this.activeCanvasId}`).style.border =
          '2px solid #009eff';

        setTimeout(() => {
          this.doInterval();
        }, 200);
      }
    },
    changeClassTo(type) {
      if (type === 'dragging') {
        data.dragStatusCount += 1;
        document.querySelector('#drop').classList.add('dragging');
        document.querySelector('#drop').classList.remove('inactive');
      } else {
        data.dragStatusCount -= 1;
        if (data.dragStatusCount <= 0) {
          document.querySelector('#drop').classList.remove('dragging');
          document.querySelector('#drop').classList.add('inactive');
        }
      }
    },
    getImageHandleDragEnter() {
      this.changeClassTo('dragging');
    },
    getImageHandleDragLeave() {
      this.changeClassTo('inactive');
    },
    getImageHandleDragOver(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    selectedFile(e) {
      this.changeClassTo('inactive');

      const selectedFiles = e.target.files;
      for (let i = 0, len = selectedFiles.length; i < len; i += 1) {
        if (this.validateImage(selectedFiles[i])) {
          this.previewImage(selectedFiles[i]);
          data.isShowStickerList = true;
        }
      }
    },
    getImageHandleDragDrop(e) {
      this.changeClassTo('inactive');

      e.preventDefault();
      const droppedFiles = e.dataTransfer.files;
      for (let i = 0, len = droppedFiles.length; i < len; i += 1) {
        if (this.validateImage(droppedFiles[i])) {
          this.previewImage(droppedFiles[i]);
          data.isShowStickerList = true;
        }
      }
    },
    handleDragStart(e) {
      const images = document.querySelectorAll('img');
      for (let i = 0; i < images.length; i += 1) {
        images[i].classList.remove('img_dragging');
      }
      e.target.classList.add('img_dragging');
    },
    handleDrop(e) {
      if (e.stopPropagation) {
        // stops the browser from redirecting.
        e.stopPropagation();
      }

      data.isPressed = false;
      document.querySelector(`#${this.activeCanvasId}`).style.border =
        '2px solid white';

      // add image
      const img = document.querySelector('.img_dragging');
      const canvasClientRect = document
        .querySelector(`#${this.activeCanvasId}`)
        .getBoundingClientRect();
      const canvasOffsetX = canvasClientRect.left + window.scrollX;
      const canvasOffsetY = canvasClientRect.top + window.scrollY;
      const newImage = new fabric.Image(img, {
        left: e.pageX - canvasOffsetX, // 마우스가 위치한 곳에 이미지 추가
        top: e.pageY - canvasOffsetY,
        lockScailingX: true,
        lockScailingY: true,
      });

      data.stickers[_.size(data.stickers)] = this.setScale(newImage, data);
      data[this.activeCanvasId].add(newImage);
      this.changeTextPriority();

      return false;
    },
    setScale(newImage, { width, height }) {
      if (newImage.width <= width && newImage.height <= height) {
        return newImage;
      }

      let scaleX = 1;
      let scaleY = 1;

      if (width > height) {
        scaleX = (height / newImage.height) * 1;
        scaleY = (height / newImage.height) * 1;
      } else if (height > width) {
        scaleX = (width / newImage.width) * 1;
        scaleY = (width / newImage.width) * 1;
      }

      newImage.scaleX = scaleX;
      newImage.scaleY = scaleY;

      return newImage;
    },
    cropperOpen(key) {
      // Cropper 열기
      this.isCropperOpened = true;
      EventBus.$emit('cropper-open', {
        url: data.img_list_tmp[this.imgNaming(key)],
        width: data.width,
        height: data.height,
        key,
      });
    },
    clearMovName() {
      // 영상 이름 비우기
      this.data.mov_name = '';
    },
    goPrev(type) {
      EventBus.$emit('move-back', type);
    },
    spinnerOpend() {
      this.isPopOpend = !this.isPopOpend;
    },
  },
};
</script>
